import { render, staticRenderFns } from "./pedigreeTree.vue?vue&type=template&id=9d1b1cd2&scoped=true"
import script from "./pedigreeTree.vue?vue&type=script&lang=js"
export * from "./pedigreeTree.vue?vue&type=script&lang=js"
import style0 from "./pedigreeTree.vue?vue&type=style&index=0&id=9d1b1cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1b1cd2",
  null
  
)

export default component.exports